// Angular Imports
import { DocumentReference, DocumentSnapshot, Firestore, doc, onSnapshot } from "@angular/fire/firestore";
import { Injectable } from '@angular/core';

// 3rd Party Imports
import { Observable, Observer } from "rxjs";


/****************************************************************************************************
 * 
 * get * - Get a single document (snapshot / promise)
 * list * - Get a list of documents (snapshot / promise)
 * subscribe * - Subscribe to a single document (observable) - real-time updates
 * 
 * 
 * 
 * 
 * 
 ****************************************************************************************************/

@Injectable({
  providedIn: 'root'
})
export class FirestoreService {

  constructor(
    private firestore: Firestore
  ) { }

  // public getDoc<T>(docRef: DocumentReference): Promise<DataWithID<T>> {
  //   return this._docRef$<T>(docRef).promise();
  // }


  /****************************************************************************************************
   * Subscribe to a document reference in Firestore with real-time updates
   *
   * @public
   * @template T
   * @param {DocumentReference} docRef
   * @returns {Observable<T>}
   ****************************************************************************************************/
  public subscribeDoc<T>(docPath: string): Observable<T> {
    const docRef = doc(this.firestore, docPath);
    return this._docRef$<T>(docRef);
  } // End of subscribeDoc<T>(docRef: DocumentReference): Observable<T>


  // public subscribeList<T>(collectionPath: string): Observable<T[]> {
  //   const collectionRef = this.firestore.collection(collectionPath);


  // }

  /****************************************************************************************************
   * Return an observable of a document reference in Firestore
   *
   * @private
   * @template T - Generic type / interface of the data
   * @param {DocumentReference} docRef
   * @returns {Observable<T>}
   ****************************************************************************************************/
  private _docRef$<T>(docRef: DocumentReference): Observable<T> {
    return new Observable<T>((observer: Observer<T>) => {
      const unsubscribe = onSnapshot(docRef,
        (documentSnapshot: DocumentSnapshot) => {
          if (documentSnapshot.exists()) {
            const data = documentSnapshot.data() as T;
            const id = documentSnapshot.id;
            observer.next({ ...data, id });
          } else {
            console.log("OBS Error: Document does not exist");
            // observer.error(new Error('Document does not exist'));
          }
        },
        (error) => { observer.error(error); }
      );
      return () => { unsubscribe(); };
    }); // End of return new Observable<T>
  } // End of _docRef$<T>

} // End of Class FirestoreService
